import { isValidPrice, isValidBasePrice, PriceList } from '@acme/b2b/pricing';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ValidateService } from '@b2b/common/services/validate';
import { ensureArray } from '@b2b/common/utils/coerce-array';
import { TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';

const EVENT_SCHEDULE_EXCEEDS_LIMIT = 'EVENT_SCHEDULE_EXCEEDS_LIMIT';

export const TemplatesCreateSchedulesCreateControllerModule = angular
  .module('acme.view.application.templates.create.schedules.create.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.permissions',
    'acme.common.service.templates',
    'acme.common.service.helpers',
    'acme.common.service.validate',
    'acme.common.service.calendar',
    'acme.common.service.themesHelper',
    'acme.common.factory.wizard',
    'acme.common.factory.notice',
    'acme.view.application.templates.create.schedules.create.removeModal.controllers',
  ])
  .controller('TemplatesCreateSchedulesCreateController', [
    '$scope',
    '$state',
    '$uibModal',
    '$timeout',
    '$filter',
    'ApiService',
    'EventTemplateData',
    'TemplatesService',
    'HelpersService',
    'CalendarService',
    'ValidateService',
    'PermissionsService',
    'ThemesHelperService',
    'NoticeFactory',
    function TemplatesCreateSchedulesCreateController(
      $scope: IScope & { templatesCreateSchedulesCreate: TODO },
      $state: StateService,
      $uibModal: UIBModalService,
      $timeout: ITimeoutService,
      $filter: IFilterService,
      ApiService: ApiService,
      EventTemplateData: TODO,
      TemplatesService: TODO,
      HelpersService: TODO,
      CalendarService: CalendarService,
      ValidateService: ValidateService,
      PermissionsService: PermissionsService,
      ThemesHelperService: ThemesHelperService,
      NoticeFactory: NoticeFactory
    ) {
      $scope.templatesCreateSchedulesCreate = {
        model: {},
        template: {},

        isSaving: false,
        isUpdate: false,

        mode: 'create',
        cap: HelpersService.cap,

        emailSetting: 'always',
        company: ThemesHelperService.getCompany(),

        type: 'standard',
        notice: new NoticeFactory(),

        init: function () {
          let title = '';

          if (EventTemplateData.data && EventTemplateData.data.success) {
            this.success.init(EventTemplateData);
          } else {
            this.error.init(EventTemplateData);
          }

          if ($state.params) {
            if ($state.params.scheduleId) {
              this.mode = 'edit';
            }

            if (($state.params.type && $state.params.type === 'private') || this.model.type === 'private') {
              for (const index in this.model.salesChannels) {
                if (this.model.salesChannels[index].channel === 'online') {
                  this.model.salesChannels[index].enabled = false;
                  break;
                }
              }
              title = this.cap(this.mode) + ' Private Event Schedule';
            } else {
              title = this.cap(this.mode) + ' Event Template Schedule';
            }
          }

          ValidateService.clearFieldTests();

          $scope.$emit('Application::contentTitleChange', {
            title: title,
            buttonLeft: {
              label: 'Close',
              action: function () {
                $scope.templatesCreateSchedulesCreate.cancel();
              },
            },
            buttonRight: {
              label: this.isMode('edit') ? 'Save' : 'Save & Continue',
              action: function () {
                const self = $scope.templatesCreateSchedulesCreate;
                if (self.isMode('create')) {
                  self.save('pricing', true);
                } else {
                  self.save(false, true);
                }
              },
            },
          });

          this.getNotificationPreference();

          $scope.$on('TemplatesCreateSchedulesCreateController::Error', this.onError);

          console.log('TemplatesCreateSchedulesCreateController::init');
        },

        getNotificationPreference: function () {
          if (this.company.hasOwnProperty('notificationPreference')) {
            this.emailSetting = this.company.notificationPreference;
          }
        },

        isMode: function (mode) {
          return this.mode === mode;
        },

        isReviewState: function (state) {
          return TemplatesService.getReviewState() === state;
        },

        isPrivateSchedule: function () {
          return this.model.type === 'private';
        },

        isState: function (state) {
          if ($state.params && $state.params.scheduleId) {
            return $state.current.name?.indexOf('application.templates.edit.schedules.edit.' + state) === 0;
          }

          return $state.current.name?.indexOf('application.templates.edit.schedules.create.' + state) === 0;
        },

        getState: function (name) {
          if ($state.params && $state.params.scheduleId) {
            return (
              'application.templates.edit.schedules.edit.' +
              name +
              '({ scheduleId: "' +
              $state.params.scheduleId +
              '" })'
            );
          }

          return 'application.templates.edit.schedules.create.' + name;
        },

        cancel: function () {
          TemplatesService.removeNewSchedule();
          $state.go('application.templates.edit.schedules');
        },

        remove: function () {
          const self = $scope.templatesCreateSchedulesCreate;

          self.showModal = $uibModal.open({
            templateUrl: 'views/application/views/templates/create/schedules/modals/removeSchedule.tpl.html',
            size: 'md',
            controller: 'TemplatesCreateSchedulesRemoveModalController',
            resolve: {
              currentSchedule: function () {
                return self.model;
              },
              SoldQuantity: function () {
                return self.model.soldQuantity;
              },
              emailSetting: function () {
                return self.emailSetting;
              },
            },
          });

          self.showModal.result.then(
            function () {
              ApiService.program.schedules
                .remove({
                  eventTemplateId: self.template.id,
                  id: self.model.id,
                })
                .then(self.success.remove, self.error.remove);
            },
            function () {}
          );
        },

        getCurrentSchedulePriceList: function (): PriceList | null {
          const self = $scope.templatesCreateSchedulesCreate;
          const found = TemplatesService.getScheduleById(self.model.id);

          return found && found.schedule ? found.schedule.priceLists?.[0] : null;
        },

        hasValidPrices: function (priceList: PriceList) {   
          const prices = ensureArray(priceList?.prices);

          return prices.every((item) => {
            return isValidPrice(item.price);
          });
        },          

        hasValidBasePrices: function (priceList: PriceList) {
          const prices = ensureArray(priceList?.prices);

          return prices.every((item) => {
            return isValidBasePrice({ basePrice: item.basePrice ?? null, price: item.price });
          });
        },

        save: function (stateName, update) {
          const self = $scope.templatesCreateSchedulesCreate;

          this.isSaving = true;
          this.isUpdate = update;

          self.notice.hideErrorMessages();
          $scope.$broadcast('TemplatesCreateSchedulesCreateController::Save');

          ValidateService.runFieldTests();

          // next tick
          $timeout(() => {
            const priceList = self.getCurrentSchedulePriceList();
            const hasValidPrices = self.hasValidPrices(priceList);
            const hasValidBasePrices = self.hasValidBasePrices(priceList);

            if (ValidateService.errors.length === 0 && hasValidBasePrices) {
              if ($state.params.scheduleId) {
                self.update(stateName);
              } else {
                self.create(stateName);
              }
            } else {
              self.isSaving = false;

              if (!hasValidBasePrices) {
                self.notice.showErrorMessages([{ message: 'Please enter a valid base price' }]);
              }

              if (!hasValidPrices) {
                self.notice.showErrorMessages([{ message: 'Please enter a valid price' }]);
              }
            }
          }, 0);
        },

        prepare: function (schedule) {
          schedule.eventTemplateId = $state.params.id;
          schedule.name = this.model.name;

          return schedule;
        },

        update: function (stateName) {
          ApiService.program.schedules
            .update(this.prepare(TemplatesService.getScheduleById($state.params.scheduleId).schedule))
            .then(function (response) {
              const self = $scope.templatesCreateSchedulesCreate;

              self.isSaving = false;

              if (stateName) {
                TemplatesService.setSchedule(response.data.payload);
                $state.go('application.templates.edit.schedules.edit.' + stateName, {
                  scheduleId: response.data.payload.id,
                });
              } else {
                self.success.update(response);
              }
              self.isUpdate = false;
            }, this.error.update);
        },

        create: function (stateName) {
          ApiService.program.schedules
            .create(this.prepare(TemplatesService.getNewSchedule().schedule))
            .then(function (response) {
              const self = $scope.templatesCreateSchedulesCreate;

              self.isSaving = false;

              if (stateName) {
                $state.go('application.templates.edit.schedules.edit.' + stateName, {
                  scheduleId: response.data.payload.id,
                });
              } else {
                self.success.create(response);
              }
              self.isUpdate = false;
            }, this.error.create);
        },

        setUpdateTimes: function (template) {
          if (template) {
            if (template.lastUpdated) {
              this.lastUpdated = $filter('date')(
                CalendarService.parseDate(template.lastUpdated),
                HelpersService.dateFormats.shortDateTime
              );
            }
            if (template.lastPublished) {
              this.lastPublished = $filter('date')(
                CalendarService.parseDate(template.lastPublished),
                HelpersService.dateFormats.shortDateTime
              );
            }
          }
        },

        showScheduleAlert: function () {
          const self = $scope.templatesCreateSchedulesCreate;
          return self.isReviewState('published') && !self.isPrivateSchedule() && $state.params.scheduleId !== undefined;
        },

        success: {
          init: function (response) {
            const self = $scope.templatesCreateSchedulesCreate;

            TemplatesService.setModel(response.data.payload);
            self.template = TemplatesService.getModel();
            self.setUpdateTimes(self.template);

            if ($state.params.scheduleId) {
              self.model = TemplatesService.getScheduleById($state.params.scheduleId).schedule;
            } else {
              self.model = TemplatesService.getNewSchedule().schedule;

              if ($state.params && $state.params.type && $state.params.type === 'private') {
                self.model.type = $state.params.type;
                for (const index in self.model.salesChannels) {
                  if (self.model.salesChannels[index].channel === 'online') {
                    self.model.salesChannels[index].enabled = false;
                    break;
                  }
                }
              }
            }
          },
          create: function (response) {
            const self = $scope.templatesCreateSchedulesCreate;

            self.isSaving = false;

            if (!self.isUpdate) {
              $state.go('application.templates.edit.schedules');
            }
          },
          update: function (response) {
            const self = $scope.templatesCreateSchedulesCreate;

            self.isSaving = false;

            if (!self.isUpdate) {
              $state.go('application.templates.edit.schedules');
            } else {
              TemplatesService.setSchedule(response.data.payload);
            }
          },
          remove: function (response) {
            $state.go('application.templates.edit.schedules');
          },
        },

        error: {
          init: function (response) {},
          create: function (response) {
            const self = $scope.templatesCreateSchedulesCreate;

            self.isSaving = false;
            self.error.generic(response);
          },
          update: function (response) {
            const self = $scope.templatesCreateSchedulesCreate;

            self.isSaving = false;
            self.error.generic(response);
          },
          remove: function (response) {
            $scope.templatesCreateSchedulesCreate.error.generic(response);
          },
          generic: function (response) {
            $scope.$emit('TemplatesCreateSchedulesCreateController::Error', { message: response.data.error, type: response.data.errorData?.type });
          },
        },

        onError: function (e, data) {
          const self = $scope.templatesCreateSchedulesCreate;

          if (data.message) {
            self.showModal = $uibModal.open({
              templateUrl: 'views/application/views/reports/create/modals/showMessage.tpl.html',
              size: 'md',
              controller: 'ReportsCreateShowMessageModalController',
              resolve: {
                currentTitle: function () {
                  return data.type === EVENT_SCHEDULE_EXCEEDS_LIMIT ? 'Limit Exceeded' : 'An error has occurred';
                },
                currentMessage: function () {
                  return data.message;
                },
                safe: function () {
                  return true;
                },
                ...(data.type === EVENT_SCHEDULE_EXCEEDS_LIMIT && { saveText: function () { return 'OK'; } }),
              },
            });
            // Invoked when modal completes with close(params)
            self.showModal.result.then(
              function () {
                if (typeof data.callback === 'function') {
                  data.callback();
                }
                if (data.state) {
                  if (data.stateParams) {
                    $state.go(data.state, data.stateParams);
                  } else {
                    $state.go(data.state);
                  }
                }
              },
              function () {
                // Do nothing
              }
            );
          }
        },
      };

      $scope.templatesCreateSchedulesCreate.init();
    },
  ]).name;
